import React from 'react'

const Dot = () => {
  return (
    <><svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.50946 10.5958C8.39701 10.5958 10.7378 8.26208 10.7378 5.38333C10.7378 2.50457 8.39701 0.170898 5.50946 0.170898C2.6219 0.170898 0.281067 2.50457 0.281067 5.38333C0.281067 8.26208 2.6219 10.5958 5.50946 10.5958Z" fill="green"/>
<defs>
<linearGradient id="paint0_linear_58_173" x1="55.2771" y1="131.303" x2="-16.1233" y2="-50.4991" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white"/>
</linearGradient>
</defs>
</svg></>
  )
}

export default Dot